import { Box, Button } from '@amzn/awsui-components-core';
import React, { useEffect, useState } from 'react';
import constants from '../../common/constants';
import {
  CollectionStory,
  ContentType,
  CollectionEventType,
} from '@amzn/awscat-pattern-library-service-model';
import { EditCollectionsEpicsTabProps } from './EditCollection';
import CollectionEpicWrapper from './CollectionEpicWrapper';
import CollectionStoryWithIndex from './CollectionStoryWithIndex';
import { SortableEpics } from './SortableCollectionEpics';
import BrowserHistory from '../utils/BrowserHistory';
import RouterPaths, { COLLECTION_VIEWER_PREFIX } from '../../common/RouterPaths';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';

function EditCollectionsEpicsTab({
  collectionId,
  epics,
  setEpics,
  saveCollection,
  disableAction,
}: EditCollectionsEpicsTabProps) {
  const mplService: IMplServiceClient = MplServiceClientFactory.create();
  const [loadingCancel, setLoadingCancel] = useState<boolean>(false);

  useEffect(() => {
    if (epics.length === 0) {
      const emptyCollectionStoryWithIndex: CollectionStoryWithIndex[] = [
        new CollectionStoryWithIndex(
          CollectionStory.create('', '', '', '', ContentType.Pattern),
          0,
        ),
      ];
      const epicItem = new CollectionEpicWrapper('', '', emptyCollectionStoryWithIndex);
      setEpics([epicItem]);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAddEpic = () => {
    const emptyCollectionStoryWithIndex: CollectionStoryWithIndex[] = [
      new CollectionStoryWithIndex(CollectionStory.create('', '', '', '', ContentType.Pattern), 0),
    ];
    const epicItem = new CollectionEpicWrapper('', '', emptyCollectionStoryWithIndex);
    setEpics([...epics, epicItem]);
  };

  const addEpicButton = (
    <Button iconName="add-plus" onClick={handleAddEpic}>
      {constants.ADD_EPIC_BUTTON}
    </Button>
  );

  const handleCancelEditingCollection = async () => {
    if (!disableAction) {
      setLoadingCancel(true);
      // @ts-expect-error TS2345 - strict migration
      await mplService.createCollectionEvent(CollectionEventType.UNLOCK, collectionId);
      setLoadingCancel(false);
    }
    BrowserHistory.push(RouterPaths.MY_COLLECTION);
  };

  const handleSaveCollection = async () => {
    if (saveCollection) {
      await saveCollection();
    }
  };

  return (
    <div>
      <SortableEpics epics={epics} setEpics={setEpics} />
      {addEpicButton}
      <Box float="right" padding={{ right: 'xs' }}>
        <Button variant="link" onClick={handleCancelEditingCollection} loading={loadingCancel}>
          {constants.CANCEL_BUTTON_TEXT}
        </Button>
        <Button variant="primary" onClick={handleSaveCollection} disabled={disableAction}>
          {constants.SAVE_COLLECTION_BUTTON_TEXT}
        </Button>
      </Box>
    </div>
  );
}

export default EditCollectionsEpicsTab;
